"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const style = {
  container: {
    flexGrow: 1,
    position: 'relative',
    margin: '24px 8px 8px 8px',
    minWidth: 120
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: 5,
    left: 0,
    right: 0
  },
  suggestion: {
    display: 'block'
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  }
};
var _default = style;
exports.default = _default;